import CastIcon from '@mui/icons-material/Cast';
import CloseIcon from '@mui/icons-material/Close';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SignalWifiConnectedNoInternet4Icon from '@mui/icons-material/SignalWifiConnectedNoInternet4';
import SignalWifiStatusbar4BarIcon from '@mui/icons-material/SignalWifiStatusbar4Bar';
import SignalWifiStatusbarConnectedNoInternet4Icon from '@mui/icons-material/SignalWifiStatusbarConnectedNoInternet4';
import WifiFindIcon from '@mui/icons-material/WifiFind';
import { Box, SvgIcon, Typography } from '@mui/material';
import React from 'react';

import { TrackedIconButton as IconButton } from '../../../../components/TrackedComponents';
import { ReactComponent as WifiRefreshSvg } from '../../../../images/WifiRefresh.svg';
import palette from '../../../ColorPalette';
import { ConnectionStatus } from './Defs';

const ICON_SX = { fontSize: 20, color: palette.black };

const CONNECTION_STATUS_MAP: Record<ConnectionStatus, React.ReactNode> = {
    connecting: <WifiFindIcon />,
    connected: <SignalWifiStatusbar4BarIcon />,
    reconnecting: (
        <SvgIcon>
            <WifiRefreshSvg />
        </SvgIcon>
    ),
    disconnected: <SignalWifiStatusbarConnectedNoInternet4Icon />,
    connection_ended: <SignalWifiConnectedNoInternet4Icon />,
};

export interface LiveStreamModalHeaderProps {
    onClose: () => void;
    title: string;
    vin?: string;
    connectionStatus: ConnectionStatus;
    statusText: string;
}

const LiveStreamModalHeader: React.FC<LiveStreamModalHeaderProps> = (props) => (
    <Box
        sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            backgroundColor: 'secondary.main',
            position: 'sticky',
            top: 0,
            p: 0.5,
            zIndex: 1500,
            flexWrap: 'wrap',
            gap: 0.5,
        }}
    >
        <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0, gap: 1, flexWrap: 'wrap' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', px: 0.5 }}>
                <CastIcon sx={{ ...ICON_SX, mr: 0.5 }} />
                <Typography variant="body2" sx={{ color: palette.black, fontWeight: 600 }}>
                    {props.title}
                </Typography>
            </Box>
            {props.vin ? (
                <Box sx={{ display: 'flex', alignItems: 'center', px: 0.5 }}>
                    <LocalShippingIcon sx={ICON_SX} />
                    <Typography
                        variant="body2"
                        sx={{
                            ml: 0.5,
                            color: palette.black,
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {props.vin}
                    </Typography>
                </Box>
            ) : null}
            <Box sx={{ display: 'flex', alignItems: 'center', px: 0.5 }}>
                <Box sx={{ display: 'inline-flex', alignItems: 'center', '& > svg': { fontSize: 20 }, ...ICON_SX }}>
                    {CONNECTION_STATUS_MAP[props.connectionStatus]}
                </Box>
                <Typography
                    variant="body2"
                    sx={{
                        ml: 0.5,
                        color: palette.black,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {props.statusText}
                </Typography>
            </Box>
        </Box>
        <IconButton id="close-live-stream-btn" size="small" onClick={props.onClose} sx={{ color: palette.black }}>
            <CloseIcon />
        </IconButton>
    </Box>
);

export default LiveStreamModalHeader;
